/**
 * Created by staffanrantzow on 10/11/16.
 */

import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { SupplierLedgerService } from 'frilans-finans';
import { GeneralError } from 'components';
import { toMoney } from '../../../amount/amount-helper';
import { getVatById } from '../../../invoice-tool-helper';

class SupplierLedgerList extends React.Component {

  static propTypes = {
    supplierLedger: PropTypes.array.isRequired,
    setSupplierLedger: PropTypes.func.isRequired,
    showDelete: PropTypes.bool
  };

  constructor (props) {
    super(props);

    this.state = {
      supplierLedger: props.supplierLedger,
      types: [],
      fetching: true,
      fetchError: false
    };

    this.renderRow = this.renderRow.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  static get defaultProps () {
    return {
      showDelete: true
    };
  }

  componentDidMount () {
    this.fetchTypes();
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.types.length > 0) {
      this.setState({
        supplierLedger: this.addTypeName(nextProps.supplierLedger, this.state.types)
      });
    }
  }

  fetchTypes () {
    SupplierLedgerService.getTypes()
      .then((types) => {
        this.setState({
          types: types,
          supplierLedger: this.addTypeName(this.props.supplierLedger, types),
          fetching: false,
          fetchError: false
        });
      })
      .catch(() => {
        this.setState({
          fetching: false,
          fetchError: true
        });
      });
  }

  /**
   * Loop through the types and add the display name to the supplier ledgers
   * @param ledgers
   * @param types supplier ledger categories/types
   * @returns {*}
   */
  addTypeName (ledgers, types) {
    for (let l of ledgers) {
      let typeId = parseInt(l.supplierLedgerTypeId);
      for (let t of types) {
        if (typeId === parseInt(t.id)) {
          l.typeName = t.displayName;
        }
      }
    }

    return ledgers;
  }

  onDeleteClick (e) {
    e.preventDefault();

    let index = parseInt(e.target.getAttribute('data-index'));
    let arr = this.props.supplierLedger.slice(0);

    arr.splice(index, 1);
    this.props.setSupplierLedger(arr);
  }

  renderRow (s, i) {
    return (
      <tr key={i}>
        <td className='col-levid'>{s.id}</td>
        <td className='col-supplier'>{s.supplierName}</td>
        <td className='col-sum'>
          <span>{toMoney(
            s.amount * (1 + (getVatById(s.taxId) / 100))
          )} <Translate content='SEK_SHORT'/></span>
        </td>
        <td><Translate content={s.file ? 'YES' : 'NO'}/></td>
        {this.props.showDelete &&
          <td className="col-delete">
            <a href='/' className='remove-link' data-index={i} onClick={this.onDeleteClick}/>
          </td>
        }
      </tr>
    );
  }

  render () {
    // Don't show the table until we have both ledgers and types
    if (this.state.supplierLedger.length === 0 || this.state.types.length === 0) {
      return false;
    }

    if (this.state.fetchError) {
      return (<GeneralError />);
    }

    return (
      <div className='table-wrapper mobile-full-width-table'>
        <table className='standard-table'>
          <thead>
            <tr>
              <th className='col-levid'><Translate content='LEV_ID'/></th>
              <th className='col-supplier'><Translate content='SUPPLIER'/></th>
              <th className='col-sum'><Translate content='INC_VAT'/></th>
              <th className='col-appended-files'><Translate content='DEDUCTION_APPENDED_FILES'/></th>
              {this.props.showDelete && <th className='col-delete'><Translate content='DELETE'/></th>}
            </tr>
          </thead>
          <tbody>
            {this.state.supplierLedger.map(this.renderRow)}
          </tbody>
        </table>
      </div>
    );
  }

}

export default SupplierLedgerList;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/list/supplier-ledger-list.js
 **/